import { useState } from 'react';
import { Crop, Maximize2 } from 'lucide-react';

const ASPECT_RATIOS = [
  { label: 'Free', value: null, icon: 'free' },
  { label: '1:1', value: 1, icon: 'square' },
  { label: '4:5', value: 4/5, icon: 'portrait' },
  { label: '16:9', value: 16/9, icon: 'landscape' },
  { label: '9:16', value: 9/16, icon: 'story' },
];

export default function CropPanel({ onCropChange, onZoomChange, zoom = 1 }) {
  const [selectedRatio, setSelectedRatio] = useState(null);

  const handleRatioSelect = (ratio) => {
    setSelectedRatio(ratio);
    onCropChange?.(ratio);
  };

  return (
    <div className="p-3 space-y-3" data-testid="crop-panel">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Crop className="w-4 h-4 text-violet-400" />
        <span>Crop & Zoom</span>
      </div>

      {/* Aspect ratio presets */}
      <div>
        <label className="text-xs text-muted-foreground mb-2 block">Aspect Ratio</label>
        <div className="flex gap-1.5">
          {ASPECT_RATIOS.map(r => (
            <button
              key={r.label}
              onClick={() => handleRatioSelect(r.value)}
              className={`flex-1 py-2 rounded-lg text-xs font-medium border transition-all ${
                selectedRatio === r.value
                  ? 'border-violet-500 bg-violet-500/10 text-violet-400'
                  : 'border-border hover:border-border'
              }`}
              data-testid={`crop-ratio-${r.label.replace(':', 'x')}`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      {/* Zoom slider */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="text-xs text-muted-foreground flex items-center gap-1">
            <Maximize2 className="w-3 h-3" /> Zoom
          </label>
          <span className="text-xs text-muted-foreground">{Math.round(zoom * 100)}%</span>
        </div>
        <input
          type="range"
          min="1"
          max="3"
          step="0.1"
          value={zoom}
          onChange={e => onZoomChange?.(parseFloat(e.target.value))}
          className="w-full accent-violet-500"
          data-testid="crop-zoom-slider"
        />
        <div className="flex justify-between text-[10px] text-muted-foreground">
          <span>100%</span><span>300%</span>
        </div>
      </div>
    </div>
  );
}
